import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Localstorage} from 'src/app/domain/service/storage/localstorage';

export const BIOMETRIC_NAMESPACE = '__biometric__';

export interface BiometricStatusState {
  enabled: boolean;
  dismissActivationReminder: boolean;
  userId: string | null;
}

const emptyState = () => ({
  enabled: false,
  dismissActivationReminder: false,
  userId: null
});

@Injectable({
  providedIn: 'root',
})
export default class BiometricStatusStore extends ComponentStore<BiometricStatusState> {
  public readonly biometricStatus$: Observable<BiometricStatusState> = this.select(state => state);

  constructor(private localStorage: Localstorage) {
    super(emptyState());
  }

  save(userId: string | null, biometricEnabled: boolean, dismissActivationReminder: boolean): void {
    this.patchState(() => ({userId, enabled: biometricEnabled, dismissActivationReminder}));
    this.localStorage.syncSet(BIOMETRIC_NAMESPACE, JSON.stringify(this.get()));
  }

  sync(): BiometricStatusState {
    return this.get();
  }

  reset(): void {
    this.patchState(() => ({
      ...emptyState()
    }));
    this.localStorage.unset(BIOMETRIC_NAMESPACE);
  }
}
